import { render, staticRenderFns } from "./ImageCreateServer.vue?vue&type=template&id=22551c57&"
import script from "./ImageCreateServer.vue?vue&type=script&lang=js&"
export * from "./ImageCreateServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports